import { StatDeclinatedIcon } from "../icons";
import List from "./List";
import Edit from "./Edit";
import Create from "./Create";

export default {
  options: {
    group: "dashboard",
    roles: ["admin"],
  },
  icon: StatDeclinatedIcon,
  list: List,
  edit: Edit,
  create: Create,
};
